var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHome(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "24px",
    viewBox: "0 0 26 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-24.000000, -743.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 728.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tab-1",
    transform: "translate(23.666667, 6.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.1614974,32.165 L21.4948499,32.165 L21.4948499,21.1817542 L24.4987138,21.1857401 L13.324117,10.4011898 L2.14951345,21.1857467 L5.16347193,21.1817568 L5.16347193,32.165 L10.4905208,32.165 L10.4905208,26.9934082 C10.4905208,25.4274113 11.7600122,24.1579199 13.3260091,24.1579199 C14.8920061,24.1579199 16.1614974,25.4274113 16.1614974,26.9934082 L16.1614974,32.165 Z",
    id: "Combined-Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHome);
export default __webpack_public_path__ + "static/media/icon-home.73d5624a.svg";
export { ForwardRef as ReactComponent };